import { NavLink } from "react-router-dom"
import { publicUrlFor } from "../../../globals/constants"

export default function Footer2() {
    return (
        <>
            <footer className="footer-light">
                <div className="ftr-bg">
                    {/* FOOTER BLOCKES START */}
                    <div className="footer-top">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-3 col-md-6">
                                    <div className="widget widget_about">
                                        <div className="logo-footer clearfix">
                                            <NavLink to="/"><img src={publicUrlFor("/assets/images/logo-light.png")} alt="" loading="lazy" /></NavLink>
                                        </div>
                                        <p>Your trusted partner for warehousing, distribution, and fulfillment solutions. We deliver efficiency and reliability for your supply chain needs.</p>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6">
                                    <div className="widget widget_services ftr-list-center">
                                        <h3 className="widget-title">Quick Links</h3>
                                        <ul>
                                            <li><NavLink to="/about-us">About</NavLink></li>
                                            <li><NavLink to="/services/services1">Services</NavLink></li>
                                            <li><NavLink to="/news">News</NavLink></li>
                                            <li><NavLink to="/faq">FAQ</NavLink></li>
                                            <li><NavLink to="/contact-us">Contact Us</NavLink></li>
                                            <li><NavLink to="/3pl-glossary">3PL Glossary</NavLink></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6">
                                    <div className="widget widget_services ftr-list-center">
                                        <h3 className="widget-title">Services</h3>
                                        <ul>
                                            <li><NavLink to="/services/services1">Warehousing</NavLink></li>
                                            <li><NavLink to="/services/services1">B2B Distribution</NavLink></li>
                                            <li><NavLink to="/services/services1">E-Com Fulfillment</NavLink></li>
                                            <li><NavLink to="/services/services1">Quick Turnaround</NavLink></li>
                                            <li><NavLink to="/services/services1">EDI & Systems</NavLink></li>
                                            <li><NavLink to="/services/services1">Bulk Storage</NavLink></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6">
                                    <div className="widget widget_services ftr-list-center">
                                        <h3 className="widget-title">Info</h3>
                                        <ul>
                                            <li><NavLink to="/remote-help">Remote Help</NavLink></li>
                                            <li><NavLink to="/privacy-policy">Privacy Policy</NavLink></li>
                                            <li><NavLink to="/terms-conditions">Terms & Conditions</NavLink></li>
                                            <li><a href="mailto:info@nivian3pl.com">info@nivian3pl.com</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* FOOTER COPYRIGHT */}
                    <div className="footer-bottom">
                        <div className="container">
                            <div className="footer-bottom-info">
                                <div className="footer-copy-right">
                                    <span className="copyrights-text">Copyright © {new Date().getFullYear()} Nivian 3PL - All Rights Reserved.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

        </>
    )
}